// import Layout from "../Layout";
// import Dashboard from "../pages/Admin_Dashboard";
// import Report from "../pages/report/Admin_Report";
// import Tools from "../pages/Admin_Tools";
// import Users from "../pages/user/Admin_Users";
// import Statistic from "../pages/statistic/Admin_Statistics";
// import StatisticUsers from "../pages/statistic/Admin_Statistics_Users";
// import StatisticDemography from "../pages/statistic/Admin_Statistics_Demography";
// import StatisticArticles from "../pages/statistic/Admin_Statistics_Articles";
// import InterestTags from "../pages/interest/Admin_Interest_Tags";
// import GeoTags from "../pages/geo/Admin_Geo_Tags";
const Layout = () =>import(/* webpackChunkName: "group-admin" */ "../Layout.vue");
const Dashboard = () =>import(/* webpackChunkName: "group-admin" */ "../pages/Admin_Dashboard.vue");
const Report = () =>import(/* webpackChunkName: "group-admin" */ "../pages/report/Admin_Report.vue");
const Tools = () =>import(/* webpackChunkName: "group-admin" */ "../pages/Admin_Tools.vue");
const Users = () =>import(/* webpackChunkName: "group-admin" */ "../pages/user/Admin_Users.vue");
const Statistic = () =>import(/* webpackChunkName: "group-admin" */ "../pages/statistic/Admin_Statistics.vue");
const StatisticUsers = () =>import(/* webpackChunkName: "group-admin" */ "../pages/statistic/Admin_Statistics_Users.vue");
const StatisticDemography = () =>import(/* webpackChunkName: "group-admin" */ "../pages/statistic/Admin_Statistics_Demography.vue");
const StatisticArticles = () =>import(/* webpackChunkName: "group-admin" */ "../pages/statistic/Admin_Statistics_Articles.vue");
const InterestTags = () => import(/* webpackChunkName: "group-admin" */ "../pages/interest/Admin_Interest_Tags.vue");
const GeoTags = () => import(/* webpackChunkName: "group-admin" */ "../pages/geo/Admin_Geo_Tags.vue");

export default [
  {
    path: "/admin",
    name: "Admin",
    component: Layout,
    redirect: { name: "Dashboard" },
    children: [
      { path: "/admin/dashboard", name: "Dashboard", component: Dashboard },
      { path: "/admin/report", name: "Report", component: Report },
      { path: "/admin/tools", name: "Tools", component: Tools },
      { path: "/admin/users", name: "Users", component: Users },
      { path: "/admin/statistics", name: "Statistic", component: Statistic },
      { path: "/admin/statisticsUsers", name: "User Statistic", component: StatisticUsers },
      { path: "/admin/statisticsDemography", name: "Demography", component: StatisticDemography },
      { path: "/admin/statisticsArticles", name: "Articles", component: StatisticArticles },
      { path: "/admin/interestTags", name: "InterestTags", component: InterestTags },
      { path: "/admin/geoTags", name: "GeoTags", component: GeoTags }
    ]
  },
];